var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:_vm.classes},[_vm._t("default"),_c('div',{staticClass:"card__acoes"},[_vm._t("acoes")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }